import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content-grid content-grid--subpage" }

import {useI18n} from "vue3-i18n";
import {useRouter} from "vue-router";
import {useMemberService, useOrganizationService} from "@/inversify.config";
import {notifyError, notifySuccess} from "@/notify";
import {Member} from "@/types/entities/member";
import {IAddMemberRequest} from "@/types/requests/addMemberRequest";
import Breadcrumbs from "@/components/layout/Breadcrumbs.vue";
import BackLinkTitle from "@/components/layout/BackLinkTitle.vue";
import Card from "@/components/layout/Card.vue";
import MemberForm from "@/components/forms/MemberForm.vue";
import {useMemberStore} from "@/stores/memberStore";
import {OrganizationType, Role} from "@/types";
import {onMounted, ref} from "vue";
import {IFullOrganization} from "@/types/entities/organization";
import Loader from "@/components/layout/Loader.vue";

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'AddMemberForm',
  props: {
    organizationId: {}
  },
  setup(__props: any) {

const props = __props;

const { t, getLocale } = useI18n()
const router = useRouter();
const memberStore = useMemberStore()
const memberService = useMemberService()
const organizationService = useOrganizationService()

let organization = ref<IFullOrganization>()

onMounted(async () => {
  organization.value = memberStore.hasRole(Role.Admin)
      ? await organizationService.getOrganizationWithId(props.organizationId)
      : await organizationService.getMyOrganization(getLocale())
})

async function handleSubmit(member : Member) {
    let succeededOrNotResponse = await memberService.addMember(member as IAddMemberRequest, props.organizationId)
    if (succeededOrNotResponse && succeededOrNotResponse.succeeded) {
        notifySuccess(t('validation.member.add.success'))
        setTimeout(() => {
            router.back();
        }, 1500);
    } else {
        let errorMessages = succeededOrNotResponse.getErrorMessages('validation.member.add');
        if (errorMessages.length == 0)
          notifyError(t('validation.member.add.errorOccurred'))
        else
          notifyError(errorMessages[0])
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Breadcrumbs, {
      title: _unref(t)(`routes.admin.children.organizations.addMember.name`)
    }, null, 8, ["title"]),
    _createVNode(BackLinkTitle, {
      title: _unref(t)(`routes.admin.children.organizations.addMember.name`)
    }, null, 8, ["title"]),
    _createVNode(Card, null, {
      default: _withCtx(() => [
        (_unref(organization))
          ? (_openBlock(), _createBlock(MemberForm, {
              key: 0,
              "is-syndicate-organization": _unref(organization)?.type === _unref(OrganizationType).RegularSyndicate,
              onFormSubmit: handleSubmit
            }, null, 8, ["is-syndicate-organization"]))
          : (_openBlock(), _createBlock(Loader, {
              key: 1,
              "is-inline": true
            }))
      ]),
      _: 1
    })
  ]))
}
}

})